import React from 'react';
import { HashRouter as Router, Route, Switch } from "react-router-dom";

import Home from './components/Home'

import "./../node_modules/slick-carousel/slick/slick.css";
import "./../node_modules/slick-carousel/slick/slick-theme.css";
import "./../node_modules/@fortawesome/fontawesome-free/css/all.css";

// Global styles
import './scss/bootstrap.scss'; 
import './scss/reset.scss';
import './scss/grid.scss';
import './scss/utilities.scss';
import './scss/buttons.scss';
import './scss/color.scss';
import './scss/tabs.scss';
import './scss/modals.scss';
import './scss/shadow.scss';
import './scss/off-canvas.scss';
import './scss/alerts.scss';

// Components
import './scss/components/video-live.scss';
import './scss/components/slick-carousel.scss';
import './scss/components/card-price.scss';
import './scss/components/wizard.scss';
import './scss/components/header.scss';

import { history } from './history'

function App() {
  
  return (
    <Router history={history}>
      <div className="App" id="outer-container">
        <div id="page-wrap" className="page-wrap-wizard">
          <Switch>
            <Route path="/:wizardId" component={Home} />
          </Switch>
        </div>
      </div>
    </Router>
  );
} 

export default App;
